// Third party
import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';

// Components
import { SecondaryButton } from '../buttons';
import UserDropdown from '../navigation/UserDropdown';
import { AnnouncementBell } from '@/views/containers/announcements';

// Utils
import { FormattedMessage } from '@/utils/i18n';
import { PERMISSIONS, userHasPermission } from '@/utils/permissions';

// Actions
import { logOpenHelpCenter } from '@/redux/modules/usage-log-deprecated';
import { ReduxState } from '@/redux/modules/types';
import Locale from '@/types/locale';
import User from '@/types/user';

type StateProps = {
  locale: Locale;
};

type DispatchProps = {
  logOpenHelpCenter: () => Promise<void>;
};

type Props = RouteComponentProps &
  DispatchProps &
  StateProps & {
    user: User;
    leftItems?: JSX.Element | Iterable<JSX.Element> | React.ReactNode[];
    middleItems?: JSX.Element | Iterable<JSX.Element>;
    rightItems?: JSX.Element | Iterable<JSX.Element>;
  };

const LinkHeader = (props: Props) => {
  const openHelpLink = () => {
    props.logOpenHelpCenter();
    /** @todo This is temporarily hardcoded for release 3.94, should be removed in favor of an enterprise config on CONN-3067 */
    const category = props.locale.startsWith('en-')
      ? 'categories/4408872951955-Link-Tutorials'
      : props.locale.startsWith('fr-')
        ? 'categories/4408872951955-FAQ-et-Dépannage'
        : '';
    window.open(`${import.meta.env.REACT_APP_HELP_SITE_URL}/${props.locale.toLocaleLowerCase().replace('en-ca', 'en-us')}/${category}`, '_blank');
  };

  const { leftItems, middleItems, rightItems, user } = props;
  return (
    <header className="link-header">
      <div className="link-header-container">
        <div className="left-items">{leftItems}</div>
        <div className="middle-items">{middleItems}</div>
        <div className="right-items">
          {rightItems && <div className="header-buttons">{rightItems}</div>}
          <SecondaryButton className="header-help-button navigation-item" noBackground icon="round-chat-interrogation" dark onClick={openHelpLink}>
            <FormattedMessage id="SiteNavigation.Help" />
          </SecondaryButton>

          {userHasPermission(user, PERMISSIONS.EXTERNAL_NOTIFICATION_CENTER) && (
            <SecondaryButton className={classNames('notification-center-trigger', 'navigation-item')} noBackground icon="notification-bell" dark />
          )}
          {userHasPermission(user, PERMISSIONS.NOTIFICATION_CENTER) && <AnnouncementBell />}

          <UserDropdown user={user} history={props.history} location={props.location} match={props.match} />
        </div>
      </div>
    </header>
  );
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  locale: state.intl.locale,
});

export default withRouter(
  connect(mapStateToProps, {
    logOpenHelpCenter,
  })(LinkHeader),
);
